import { gsap } from "../../animations/gsapSetup.ts";
import { DeviceMockup } from "../../components/common/DeviceMockup.tsx";
import { useGsapScrollTrigger } from "../../hooks/useGsapScrollTrigger.ts";
import { useIsMobile } from "../../hooks/useMediaQuery.ts";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";
import { useI18n } from "../../i18n/context.tsx";
import styles from "./WatchIntegration.module.css";

export function WatchIntegration() {
  const reducedMotion = useReducedMotion();
  const isMobile = useIsMobile();
  const { t } = useI18n();

  const ref = useGsapScrollTrigger(
    (el) => {
      if (reducedMotion) return;

      const watchWrap = el.querySelector(`.${styles.watchWrap}`);
      const phoneWrap = el.querySelector(`.${styles.phoneWrap}`);
      const heading = el.querySelector(`.${styles.heading}`);

      if (isMobile) {
        gsap.from([heading, watchWrap, phoneWrap], {
          y: 40,
          opacity: 0,
          duration: 0.8,
          stagger: 0.2,
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        });
        return;
      }

      gsap.from(heading, {
        y: 30,
        opacity: 0,
        duration: 0.8,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.from(watchWrap, {
        y: 120,
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });

      gsap.from(phoneWrap, {
        y: -80,
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });
    },
    [isMobile],
  );

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.heading}>
        <h2 className={styles.title}>{t.classic.watchTitle}</h2>
        <p className={styles.description}>{t.classic.watchDesc}</p>
      </div>
      <div className={styles.devices}>
        <div className={styles.watchWrap}>
          <DeviceMockup device="watch">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "var(--color-gray-500)",
                fontSize: "var(--text-xs)",
              }}
            >
              Watch UI
            </div>
          </DeviceMockup>
        </div>
        <div className={styles.phoneWrap}>
          <DeviceMockup device="iphone">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "var(--color-gray-500)",
                fontSize: "var(--text-sm)",
              }}
            >
              iPhone UI
            </div>
          </DeviceMockup>
        </div>
      </div>
    </section>
  );
}
